module.exports = __webpack_public_path__ + "static/media/MS.cbd3f274.svg";